export const CAPTCHA_PROVIDERS_FOR_TOGGLE = ['yandex', 'vk'] as const;

// разделяем так на всякий случай, чтобы нельзя было подпихнуть mock в урле
export const CAPTCHA_PROVIDERS = [
  ...CAPTCHA_PROVIDERS_FOR_TOGGLE,
  'mock',
] as const;
